import React, { useState } from 'react';
import { Button, Input, Table, Modal, message, Typography } from 'antd';
import { searchResetPasswordUsers, resetUserPassword, UsuarioResetPassword } from '../../../services/supportSuite';



const { Title } = Typography;

const columnsDef = (
  onReset: (user: UsuarioResetPassword) => void,
  loadingId: number | null
) => [
  {
    title: 'Usuario',
    dataIndex: 'nombre_de_usuario',
    key: 'nombre_de_usuario',
  },
  {
    title: 'Nombre',
    dataIndex: 'nombre_completo',
    key: 'nombre_completo',
  },
  {
    title: 'Acción',
    key: 'accion',
  render: (_: any, record: UsuarioResetPassword) => (
      <Button
        type="primary"
        danger
        onClick={() => onReset(record)}
  loading={loadingId === record.id_usuario}
      >
        Reiniciar Contraseña
      </Button>
    ),
  },
];

const ResetPassword: React.FC = () => {
  const [usuarios, setUsuarios] = useState<UsuarioResetPassword[]>([]);
  const [busqueda, setBusqueda] = useState('');
  const [loading, setLoading] = useState(false);
  // Eliminado setMensaje, se usará message.success
  const [modal, setModal] = useState<{visible: boolean, usuario?: UsuarioResetPassword}>({visible: false});
  const [loadingId, setLoadingId] = useState<number | null>(null);

  const buscar = async () => {
    setLoading(true);
  // No se limpia mensaje, se usará message.success
    try {
      const res = await searchResetPasswordUsers(busqueda);
      setUsuarios(res.filter((u) => !u.bloqueado));
    } catch (e) {
      // @ts-ignore
      message.error(e?.response?.data?.message || 'Error al buscar usuarios');
    }
    setLoading(false);
  };

  const resetear = async (usuario: UsuarioResetPassword) => {
    setLoadingId(usuario.id_usuario);
    try {
      const msg = await resetUserPassword(usuario.id_usuario);
  message.success(msg || `Contraseña de ${usuario.nombre_de_usuario} reseteada con éxito`);
      setModal({visible: false});
      buscar();
    } catch (e) {
      // @ts-ignore
      message.error(e?.response?.data?.message || 'Error al resetear contraseña');
    }
    setLoadingId(null);
  };

  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: 24 }}>
      <Title level={3}>Reseteo de Contraseña</Title>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <Input
          value={busqueda}
          onChange={e => setBusqueda(e.target.value)}
          placeholder="Ingrese Usuario"
          onPressEnter={buscar}
          allowClear
          style={{ flex: 1 }}
        />
        <Button type="primary" onClick={buscar} loading={loading}>
          Buscar
        </Button>
      </div>
  {/* El mensaje de éxito ahora se muestra como notificación emergente */}
      <Table
        columns={columnsDef((usuario) => setModal({visible: true, usuario}), loadingId)}
        dataSource={usuarios}
  rowKey="id_usuario"
        pagination={{ pageSize: 10 }}
        locale={{ emptyText: 'Sin resultados' }}
      />
      <Modal
        visible={modal.visible}
        title="Confirmar reseteo de contraseña"
        onOk={() => modal.usuario && resetear(modal.usuario)}
        onCancel={() => setModal({visible: false})}
        okText="Sí, resetear"
        cancelText="Cancelar"
  confirmLoading={loadingId === modal.usuario?.id_usuario}
      >
        <p>
          ¿Está seguro que desea resetear la contraseña del usuario <b>{modal.usuario?.nombre_de_usuario}</b>?
          <br />La contraseña será cambiada al valor por defecto.
        </p>
      </Modal>
    </div>
  );
};

export default ResetPassword;
